export default __webpack_public_path__ + "static/media/pic5.a7e7b8ef.jpg";